<template>
  

  <div class="my-3">

    <h6 class="col my-1 text-center">
      <strong>Tabla de Exámenes AS400</strong>
    </h6>

    <b-row>

      <b-col v-if="examenesList.length > 0">
        <b-table 
          :items="examenesList" 
          :fields="tableFields"
          class="text-center"
          responsive small
        >
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>

          <template #cell(examenes)="data">
            <div
              v-for="(examen, index) in data.item.examenes"
              :key="index"
            >
              {{ examen.codigo }} - {{ examen.descripcion }}
            </div>
          </template>

          <template #cell(acciones)="data">
            <b-button
              variant="danger"
              size="sm"
              style="cursor: pointer"
              @click="removeItem(data.item.id)"
            >
              <font-awesome-icon
                icon="circle-xmark"
                style="color: rgb(255, 255, 255)"
              />
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>

  </div>
  
</template>

<script>
export default {

  name: "ExamenesList",

  props: {
    value: {
      type: Array,
      required: true
    },

    onlyView: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      examenesList: this.value
    }
  },


  methods: {
    removeItem() {}
  },

  computed: {
    tableFields(){
      const baseFields = [
        { 
          key: "index", 
          label: "N°", 
          thClass: "text-center", 
          tdClass: "text-center" 
        },
        { 
          key: "numeroOrden", 
          label: "# Orden",    
          thClass: "text-center" 
        },
        { 
          key: "examenes",  
          label: "Examenes",  
          thClass: "text-left",
          tdClass: "text-left" 
        },

        { 
          key: "justificacion",  
          label: "Justificacion",  
          thClass: "text-left",
          tdClass: "text-left" 
        },
      ];


      if (this.onlyView) return baseFields;

      return [
        ...baseFields, 
        {
          key     : "acciones",
          label   : "acciones",
          sortable: true,
          thClass : "text-center",
          tdClass : "text-right",
        }
      ];
    }
  }
}
</script>